import {useState} from 'react';
import {motion} from 'framer-motion';
import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import BrandStatement from './components/BrandStatement';
import CollectionSection from './components/CollectionSection';
import LookbookSlider from './components/LookbookSlider';
import ProductSection from './components/ProductSection';
import StorySection from './components/StorySection';
import Testimonials from './components/Testimonials';
import InstagramSection from './components/InstagramSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import SiteFooter from './components/SiteFooter';
import WhatsAppFloat from './components/WhatsAppFloat';
import BagDrawer from './components/BagDrawer';

function App() {
  const [bagItems,setBagItems] = useState([]);
  const [bagOpen,setBagOpen] = useState(false);

  const addToBag = (product) => {
    setBagItems(curr => {
      const ex = curr.find(i => i.id === product.id);
      return ex ? curr.map(i => i.id === product.id ? {...i,quantity: i.quantity + 1} : i) : [...curr,{...product,quantity: 1}];
    });
    setBagOpen(true);
  };

  const changeQty = (id,amt) => setBagItems(c => c.map(i => i.id === id ? {...i,quantity: i.quantity + amt} : i).filter(i => i.quantity > 0));
  const bagCount = bagItems.reduce((t,i) => t + i.quantity,0);

  return (
    <div>
      <SiteHeader bagCount={bagCount} onBagOpen={() => setBagOpen(true)} />
      <main>
        <Hero />
        <BrandStatement />
        <CollectionSection />
        <LookbookSlider />
        <div className="marquee-strip">
          <motion.div className="marquee-track" animate={{x: ['0%','-50%']}} transition={{repeat: Infinity,duration: 30,ease: 'linear'}}>
            {[0,1].map(n => <span key={n}>NEW SEASON <i>✦</i> THE ROSE EDIT <i>✦</i> COMPLIMENTARY SHIPPING <i>✦</i> STYLED OVER WHATSAPP <i>✦</i></span>)}
          </motion.div>
        </div>
        <ProductSection onAdd={addToBag} />
        <StorySection />
        <Testimonials />
        <InstagramSection />
        <FAQSection />
        <FinalCTA />
      </main>
      <SiteFooter />
      <WhatsAppFloat />
      <BagDrawer isOpen={bagOpen} items={bagItems} onClose={() => setBagOpen(false)} onChangeQuantity={changeQty} />
    </div>
  );
}

export default App;
